import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.admin.metrics').factory('MetricsSvc', MetricsSvc);

    MetricsSvc.$inject = ['$http', 'CONF'];

    /* @ngInject */
    function MetricsSvc($http, CONF) {
        var exports = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return exports;

        function getData(url) {
            return $http.get(url).then(function(response) {
                return response.data;
            });
        }

        function getMetrics(application) {
            var url = CONF.apiContext;
            switch (application) {
                case 'kiss':
                    url += CONF.apiBaseUrl + '/v1/metrics';
                    break;
                case 'epdf':
                    url += CONF.proxyEpdf + CONF.apiBaseUrl + '/v1/metrics';
                    break;
                case 'zedoc':
                    url += CONF.proxyZeDoc + CONF.apiBaseUrl + '/v1/metrics';
                    break;
            }
            return getData(url);
        }

        function threadDump(application) {
            var url = CONF.apiContext;
            switch (application) {
                case 'kiss':
                    url += CONF.apiBaseUrl + '/v1/management/dump';
                    break;
                case 'epdf':
                    url += CONF.proxyEpdf + CONF.apiBaseUrl + '/v1/management/dump';
                    break;
                case 'zedoc':
                    url += CONF.proxyZeDoc + CONF.apiBaseUrl + '/v1/management/dump';
                    break;
            }
            return getData(url);
        }
    }
})();
